import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';

import styles from './PricingTable.module.css';

export default class PricingTable extends Component {
  render() {
    return (
      <div>
        <h3 className={styles.title}>Vergleichen Sie die Startpartner Pakete und sichern Sie sich
          <br />Ihr Quickdoctor-Angebot</h3>

        <Row>
          <Col lg={{ size: 10 }} xs={12}>
            <div className={styles.tableWrapper}>
              <table className={styles.table}>
                <thead>
                <tr>
                  <th></th>
                  <th>Unlimited / Monat</th>
                  <th><span>Professional</span> / Monat</th>
                  <th>Essential / Monat</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>1. Behandler</td>
                  <td className={styles.price}>91<span className={styles.euro}>€</span> <span
                    className={styles.smaller}>inkl. MwSt.</span></td>
                  <td className={styles.price}>55<span className={styles.euro}>€</span> <span
                    className={styles.smaller}>inkl. MwSt.</span></td>
                  <td className={styles.price}>37<span className={styles.euro}>€</span> <span
                    className={styles.smaller}>inkl. MwSt.</span></td>
                </tr>
                <tr>
                  <td>2. Behandler</td>
                  <td className={styles.price}>69<span className={styles.euro}>€</span> <span
                    className={styles.smaller}>inkl. MwSt.</span></td>
                  <td className={styles.price}>42<span className={styles.euro}>€</span> <span
                    className={styles.smaller}>inkl. MwSt.</span></td>
                  <td className={styles.price}>28<span className={styles.euro}>€</span> <span
                    className={styles.smaller}>inkl. MwSt.</span></td>
                </tr>
                <tr>
                  <td>3. Behandler</td>
                  <td className={styles.price}>52<span className={styles.euro}>€</span> <span
                    className={styles.smaller}>inkl. MwSt.</span></td>
                  <td className={styles.price}>31<span className={styles.euro}>€</span> <span
                    className={styles.smaller}>inkl. MwSt.</span></td>
                  <td className={styles.price}>21<span className={styles.euro}>€</span> <span
                    className={styles.smaller}>inkl. MwSt.</span></td>
                </tr>
                <tr>
                  <td>4. Behandler</td>
                  <td className={styles.price}>39<span className={styles.euro}>€</span> <span
                    className={styles.smaller}>inkl. MwSt.</span></td>
                  <td className={styles.price}>24<span className={styles.euro}>€</span> <span
                    className={styles.smaller}>inkl. MwSt.</span></td>
                  <td className={styles.price}>16<span className={styles.euro}>€</span> <span
                    className={styles.smaller}>inkl. MwSt.</span></td>
                </tr>
                <tr>
                  <td>Ab dem 5. Behandler</td>
                  <td className={styles.price}>29<span className={styles.euro}>€</span> <span
                    className={styles.smaller}>inkl. MwSt.</span></td>
                  <td className={styles.price}>18<span className={styles.euro}>€</span> <span
                    className={styles.smaller}>inkl. MwSt.</span></td>
                  <td className={styles.price}>12<span className={styles.euro}>€</span> <span
                    className={styles.smaller}>inkl. MwSt.</span></td>
                </tr>
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PricingTable/PricingTable.js